// removed by extract-text-webpack-plugin
module.exports = {"header":"kk5cpu0YWQFcTlg46gZJ0","brand":"_3TlTmmRXHzeUF4lhkJT7EY","navigation":"_3Zr60QfyQ2JgCbP7p1bfiA","public":"_1SyWxDHz5kT2ldbVNzPHmZ","active":"wLJ8W8dUl2ALSvqGOAK0b","hidden":"_3xBy2IdLCsSqIyWLMjWnie"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MainHeader/MainHeader.mod.css
// module id = 1017
// module chunks = 0